module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_0.0e4f0980.png";